var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMobileDis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.271 3.082h7.61c1.4 0 2.536 1.136 2.536 2.536v12.683c0 1.401-1.136 2.537-2.536 2.537h-7.61A2.536 2.536 0 0 1 7.735 18.3v-5.074h.421v1.268a1.268 1.268 0 0 0 2.165.897l2.537-2.536a1.268 1.268 0 0 0 0-1.794l-2.537-2.536a1.268 1.268 0 0 0-2.165.896v1.269h-.421V5.618c0-1.4 1.135-2.536 2.536-2.536zM7.733 10.69V8.154H5.198V5.618A5.073 5.073 0 0 1 10.271.545h7.61a5.073 5.073 0 0 1 5.073 5.073v12.683a5.073 5.073 0 0 1-5.073 5.073h-7.61a5.073 5.073 0 0 1-5.073-5.073v-2.537h2.535v-2.537H5.198v2.537h-.001v-2.537H1.815a1.268 1.268 0 1 1 0-2.536h3.382V8.154h.001v2.537h2.535z",
    fill: "#ABABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.547 .545)",
    d: "M0 0h22.909v22.909H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMobileDis);
export default __webpack_public_path__ + "static/media/loginMobile-dis.ff5cade685501aa0c55369e961bc8443.svg";
export { ForwardRef as ReactComponent };